export default "__VITE_ASSET__BLgPMDPM__"